import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModulesDataService {

  constructor() { }

  saveLoadedModules(modules: any): void {
    localStorage.setItem('modules', JSON.stringify(modules));
  }

  saveLoadedAppModules(modules: any): void {
    localStorage.setItem('appModules', JSON.stringify(modules));
  }

  getLoadedModules(): any {
    const modules = localStorage.getItem('modules');
    return JSON.parse(modules);
  }

  getLoadedAppModules(): any {
    const appModules = localStorage.getItem('appModules');
    return JSON.parse(appModules);
  }

  clearModules(): void {
    localStorage.removeItem('modules');
    localStorage.removeItem('appModules');
    localStorage.removeItem('assigned_modules')
  }

  getParentModule(parentId: any): any {
    return this.getLoadedModules()?.filter(module => module.id === parentId);
  }

  findModuleByName(name: string): any | undefined {
    return this.getLoadedModules()?.find(module => module.name === name);
  }

  getChildModules(parentId: number): any[] {
    return this.getLoadedModules()?.filter(module => module.parent === parentId);
  }
}
